import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import {connect} from "react-redux";
import {actionCreators} from "../redux/sagas/multiLocationOverview/multiLocationOverview";

export default connect(
  state => ({
    filterType: "FilterLevel",
    options: state.multiLocationOverview.availableFilters.level_3,
    placeholder: "Please Select",
    selectAll: true,
    initFiltersLoaded: state.multiLocationOverview.initFiltersLoaded,
    enableOnly: true,
    numberDisplayed: 0,
    includeSelectAll: true,
    defaultSelected: false,
    haveOnSelectChange: false
  }),

  {
    updateFilterLevel: data => actionCreators.updateSelectedThirdLevelFilters(data),
    updateFilters: data => actionCreators.updateFiltersRequest({name: "FilterLevelThird", data: data})
  }
)(MultiSelectDropdown);
